"use client";
import type { GameData } from "@/app/games/(details)/types";
import { RightNavHeader } from "@/components/layout/nav/RightNavHeader";
import { usePassportProvider } from "@/context";
import { useGameDetailsContext } from "@/context/GameDetailsContext";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { cn } from "@/lib/utils";
import { MotivationState } from "./MotivationState";
import { Quests } from "./Quests";

interface RightPanelProps {
  className?: string;
  gameData: GameData;
  showOnboardingModal: () => void;
}

export const RightPanel = ({
  className,
  gameData,
  showOnboardingModal,
}: RightPanelProps) => {
  const { isWishlisted, addToWishlist } = useGameDetailsContext();
  const { isLoggedIn } = usePassportProvider();

  const { newOnboardingFlow8BallNov25Gpt } = useFeatureFlags();

  return (
    <div
      className={cn(
        "md:flex hidden flex-col h-full border-l border-white/10 bg-white/[0.01] backdrop-blur-[32px] items-center overflow-y-auto px-5 py-10",
        className,
      )}
    >
      {isLoggedIn ? (
        // min-w and negative margin to make sure it looks exactly the same as the RightNav
        <RightNavHeader
          className="min-w-[330px] m-[-1rem]"
          signInCallback={() => {}}
        />
      ) : null}
      {isWishlisted ? (
        <Quests gameData={gameData} />
      ) : (
        <MotivationState
          gameData={gameData}
          onGetStartedClick={
            newOnboardingFlow8BallNov25Gpt ? showOnboardingModal : addToWishlist
          }
        />
      )}
    </div>
  );
};
